// import React, { useState, useRef, useEffect } from "react";
// import { Button, Modal } from "react-bootstrap";

// const AudioLibraryPopup = ({ onClose, onSelect,setShowAudioLibrary, showAudioLibrary }) => {
//   const [selectedAudio, setSelectedAudio] = useState(null);
//   const [playingAudio, setPlayingAudio] = useState(null);
//   const audioRefs = useRef({});

//   // Mock audio library data - replace with your actual data source
//   const audioLibrary = [
//     {
//       id: 1,
//       name: "Male Voice Sample 1",
//       url: "/audio/male-voice-1.mp3",
//       duration: "0:15",
//       type: "male"
//     },
//     {
//       id: 2,
//       name: "Female Voice Sample 1",
//       url: "/audio/female-voice-1.mp3",
//       duration: "0:12",
//       type: "female"
//     },
//     {
//       id: 3,
//       name: "Male Voice Sample 2",
//       url: "/audio/male-voice-2.mp3",
//       duration: "0:18",
//       type: "male"
//     },
//     {
//       id: 4,
//       name: "Female Voice Sample 2",
//       url: "/audio/female-voice-2.mp3",
//       duration: "0:20",
//       type: "female"
//     },
//     {
//       id: 5,
//       name: "Neutral Voice Sample",
//       url: "/audio/neutral-voice.mp3",
//       duration: "0:14",
//       type: "neutral"
//     }
//   ];

//   const handlePlayPause = (audio) => {
//     const audioElement = audioRefs.current[audio.id];
//     if (!audioElement) return;

//     if (playingAudio === audio.id) {
//       audioElement.pause();
//       setPlayingAudio(null);
//     } else {
//       // Pause any currently playing audio
//       Object.values(audioRefs.current).forEach(el => {
//         if (el) el.pause();
//       });

//       audioElement.play();
//       setPlayingAudio(audio.id);
//     }
//   };

//   const handleAudioEnd = (audioId) => {
//     setPlayingAudio(null);
//   };

//   const handleSelectAudio = (audio) => {
//     setSelectedAudio(audio);
//   };

//   const handleConfirmSelection = () => {
//     if (selectedAudio) {
//       onSelect(selectedAudio.url, selectedAudio.name);
//     }
//   };

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) {
//       onClose();
//     }
//   };

//   // Cleanup audio when component unmounts
//   useEffect(() => {
//     return () => {
//       Object.values(audioRefs.current).forEach(audioElement => {
//         if (audioElement) {
//           audioElement.pause();
//           audioElement.src = '';
//         }
//       });
//     };
//   }, []);

//   return (
//     <>
//      <Modal
//         show={showAudioLibrary}
//         onHide={handleOverlayClick}
//         backdrop="static"
//         keyboard={false}
//         modal
//          centered
//          scrollable
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Modal title</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="p-6 overflow-y-auto max-h-[calc(80vh-140px)]">
//           <div className="space-y-3">
//             {audioLibrary.map((audio) => (
//               <div
//               style={{background:  selectedAudio?.id === audio.id
//                     && '#ebc0ff'}}
//                 key={audio.id}
//                 className={`p-4 my-2 border rounded-3 cursor-pointer transition-colors ${
//                   selectedAudio?.id === audio.id
//                     && 'active'

//                 }`}
//                 onClick={() => handleSelectAudio(audio)}
//               >
//                 <div className="d-flex align-items-center justify-content-between">
//                   <div className="d-flex align-items-center space-x-3">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handlePlayPause(audio);
//                       }}
//                       className="bg-blue-500 hover:bg-blue-600 btn bg-primary text-white rounded-pill d-flex align-items-center justify-content-center transition-colors"
//                       style={{height: 40, width: 40}}
//                     >
//                       {playingAudio === audio.id ? (
//                         <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//                           <rect x="2" y="1" width="2" height="10" fill="currentColor" />
//                           <rect x="8" y="1" width="2" height="10" fill="currentColor" />
//                         </svg>
//                       ) : (
//                         <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//                           <path d="M2 1L10 6L2 11V1Z" fill="currentColor" />
//                         </svg>
//                       )}
//                     </button>
//                     <div className="ps-3">
//                       <h6 className="fw-sbold text-gray-900 m-0">{audio.name}</h6>
//                       <p className="text-sm text-gray-500 m-0 fw-sbold">
//                         {audio.type.charAt(0).toUpperCase() + audio.type.slice(1)} • {audio.duration}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="d-flex items-center">
//                     {selectedAudio?.id === audio.id && (
//                       <div className="w-4 h-4 bg-blue-500 rounded-pill d-flex align-items-center justify-center me-2">
//                         <div className="w-2 h-2 bg-white rounded-pill"></div>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Hidden audio elements */}
//                 <audio
//                   ref={(el) => {
//                     if (el) audioRefs.current[audio.id] = el;
//                   }}
//                   src={audio.url}
//                   onEnded={() => handleAudioEnd(audio.id)}
//                   className="hidden"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Footer */}

//         </Modal.Body>
//         <Modal.Footer>

//            <button
//             onClick={onClose}
//             className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleConfirmSelection}
//             // disabled={!selectedAudio}
//             className={`px-4 py-2 rounded-lg transition-colors commonBtn btn text-white ${
//               selectedAudio
//                 ? 'bg-blue-500 hover:bg-blue-600 text-white'
//                 : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//             }`}
//           >
//             Select Audio
//           </button>
//         </Modal.Footer>
//       </Modal>

//     </>
//   );
// };

// export default AudioLibraryPopup;

import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const AudioLibraryPopup = ({
  showAudioLibrary,
  setShowAudioLibrary,
  onClose,
  onSelect,
}) => {
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [playingAudio, setPlayingAudio] = useState(null);
  const audioRefs = useRef({});

  const { audioList, loading } = useSelector((state) => state.Appearance);
  console.log(audioList, "audioList");

  const handlePlayPause = (audio) => {
    const audioElement = audioRefs.current[audio.voice_id];

    if (!audioElement) {
      console.error("Audio element not found for voice_id:", audio.voice_id);
      return;
    }

    if (!audio.preview_url) {
      console.error("No preview URL for audio:", audio.name);
      return;
    }

    if (playingAudio === audio.voice_id) {
      audioElement.pause();
      setPlayingAudio(null);
    } else {
      // Pause any currently playing audio
      Object.values(audioRefs.current).forEach((el) => {
        if (el && !el.paused) {
          el.pause();
        }
      });

      // Ensure we're using the correct URL
      if (audioElement.src !== audio.preview_url) {
        console.log("Setting audio src to:", audio.preview_url);
        audioElement.src = audio.preview_url;
        audioElement.load(); // Reload the audio element with new source
      }

      // Reset current time and play
      audioElement.currentTime = 0;
      const playPromise = audioElement.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Successfully playing:", audio.preview_url);
            setPlayingAudio(audio.voice_id);
          })
          .catch((error) => {
            console.error("Error playing audio:", error);
            console.error("Audio URL:", audio.preview_url);
            console.error("Audio element src:", audioElement.src);
            console.error("Audio element:", audioElement);
          });
      }
    }
  };

  const handleAudioEnd = (audioId) => {
    setPlayingAudio(null);
  };

  const handleSelectAudio = (audio) => {
    setSelectedAudio(audio);
  };

  const handleConfirmSelection = () => {
    if (selectedAudio) {
      // Pass audio URL, name, and voice_id to parent
      onSelect(
        selectedAudio.preview_url,
        selectedAudio.name,
        selectedAudio.voice_id
      );
      setSelectedAudio(null); // Reset selection
      setPlayingAudio(null); // Stop any playing audio
      // Pause all audio elements
      Object.values(audioRefs.current).forEach((el) => {
        if (el && !el.paused) {
          el.pause();
        }
      });
    }
  };

  const handleClose = () => {
    setSelectedAudio(null); // Reset selection
    setPlayingAudio(null); // Stop any playing audio
    // Pause all audio elements
    Object.values(audioRefs.current).forEach((el) => {
      if (el && !el.paused) {
        el.pause();
      }
    });
    onClose();
  };

  // Cleanup audio when component unmounts
  useEffect(() => {
    return () => {
      Object.values(audioRefs.current).forEach((audioElement) => {
        if (audioElement) {
          audioElement.pause();
          audioElement.src = "";
        }
      });
    };
  }, []);

  // Reset selected audio when modal closes
  useEffect(() => {
    if (!showAudioLibrary) {
      setSelectedAudio(null);
      setPlayingAudio(null);
    }
  }, [showAudioLibrary]);

  return (
    <Modal
      show={showAudioLibrary}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      scrollable
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Audio Library</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "calc(80vh-140px)" }}
        >
          {loading ? (
            <div className="text-center py-4">
              <p className="text-muted">Loading audio library...</p>
            </div>
          ) : audioList && audioList.length > 0 ? (
            <div className="d-flex flex-column gap-3">
              {audioList.map((audio) => (
                <div
                  key={audio.voice_id}
                  style={{
                    background:
                      selectedAudio?.voice_id === audio.voice_id
                        ? "#ebc0ff"
                        : "transparent",
                  }}
                  className={`p-4 border rounded-3 cursor-pointer transition-colors ${
                    selectedAudio?.voice_id === audio.voice_id
                      ? "active border-primary"
                      : ""
                  }`}
                  onClick={() => handleSelectAudio(audio)}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePlayPause(audio);
                        }}
                        className="bg-blue-500 hover:bg-blue-600 btn bg-primary text-white rounded-pill d-flex align-items-center justify-content-center transition-colors me-3"
                        style={{ height: 40, width: 40 }}
                        disabled={!audio.preview_url}
                      >
                        {playingAudio === audio.voice_id ? (
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <rect
                              x="2"
                              y="1"
                              width="2"
                              height="10"
                              fill="currentColor"
                            />
                            <rect
                              x="8"
                              y="1"
                              width="2"
                              height="10"
                              fill="currentColor"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path d="M2 1L10 6L2 11V1Z" fill="currentColor" />
                          </svg>
                        )}
                      </button>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold text-dark m-0">{audio.name}</h6>
                        <div className="d-flex align-items-center gap-1 text-sm text-muted">
                          {audio.labels?.gender && (
                            <span className="text-capitalize">
                              {audio.labels.gender}
                            </span>
                          )}
                          {audio.labels?.age && (
                            <>
                              <span>•</span>
                              <span className="text-capitalize">
                                {audio.labels.age}
                              </span>
                            </>
                          )}
                          {audio.labels?.accent && (
                            <>
                              <span>•</span>
                              <span className="text-capitalize">
                                {audio.labels.accent}
                              </span>
                            </>
                          )}
                          {audio.category && (
                            <>
                              <span>•</span>
                              <span className="text-capitalize">
                                {audio.category}
                              </span>
                            </>
                          )}
                        </div>
                        {audio.description && (
                          <p
                            className="text-xs text-muted mt-1 mb-0"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {audio.description}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      {selectedAudio?.voice_id === audio.voice_id && (
                        <div
                          className="bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: 16, height: 16 }}
                        >
                          <div
                            className="bg-white rounded-circle"
                            style={{ width: 8, height: 8 }}
                          ></div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Audio element - dynamically set source */}
                  {audio.preview_url && (
                    <audio
                      ref={(el) => {
                        if (el) {
                          audioRefs.current[audio.voice_id] = el;
                          // Don't set src here, we'll set it dynamically in handlePlayPause
                          el.crossOrigin = "anonymous";
                          el.onerror = (e) => {
                            console.error(
                              "Audio loading error for:",
                              audio.name
                            );
                            console.error("Failed URL:", el.src);
                            console.error("Expected URL:", audio.preview_url);
                            console.error("Error details:", e);
                          };
                        }
                      }}
                      onEnded={() => handleAudioEnd(audio.voice_id)}
                      preload="none"
                      style={{ display: "none" }}
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted">No audio files available</p>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleClose}
          className="px-4 py-2 text-muted border border-secondary rounded-3 hover:bg-light transition-colors"
        >
          Cancel
        </button>
        <button
        style={{opacity: selectedAudio ? "100": "50"}}
          onClick={handleConfirmSelection}
          disabled={!selectedAudio}
          className={`px-4 py-2 text-white rounded-3 transition-colors commonBtn btn text-white `}
          
        >
          Select Audio
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AudioLibraryPopup;
